import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { CasePreviewTabContext } from 'app/edozvola/case-form-preview-wrapper';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';

export const getCaseContext = () => {
  const location = useLocation();

  if (location.pathname.includes('/cases-preview')) {
    return useContext(CasePreviewTabContext);
  }

  return useContext(CaseTabContext);
}
